import { Stack, Typography } from "@mui/joy";
import { isMobile } from "react-device-detect";
import { theme } from "styles/theme";
import ListButton from "../../common/ListButton";
import useIsInappWebview from "../../../hooks/useIsInappWebview";
import useIsRecordSeparatedPage from "../../../hooks/useIsRecordSeparatedPage";

function StatisticsIcon() {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15 16.6668V8.3335"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M10 16.6668V3.3335"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M5 16.6665V11.6665"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}

export default function OpenStatisticsButton({
  isOpen,
  open,
}: {
  isOpen: boolean;
  open: () => void;
}) {
  const isRecordSeparatedPage = useIsRecordSeparatedPage();
  const isTaskContainerSmall = useIsInappWebview();

  return isTaskContainerSmall && !isRecordSeparatedPage ? (
    <Stack
      direction={"column"}
      spacing={"6px"}
      alignItems="center"
      justifyContent={"center"}
      sx={{
        flexShrink: 0,
        cursor: "pointer",
        ...(isMobile
          ? {
              "&:active": {
                opacity: 0.5,
              },
            }
          : {
              "&:hover": {
                opacity: 0.5,
              },
            }),

        width: "38px",
        height: "100%",
        whiteSpace: "nowrap",
        borderRadius: "6px",
      }}
      onClick={open}
    >
      <StatisticsIcon />
      <Typography
        variant={"Caption"}
        sx={{
          color: theme.vars.palette.Content.Strong,
          fontWeight: 500,
        }}
      >
        통계
      </Typography>
    </Stack>
  ) : (
    <ListButton icon={<StatisticsIcon />} text={"연습 통계"} onClick={open} />
  );
}
